import { getElementDiv, prepareRender, renderRoadmap, addDisplayTile } from "@/modules/commonRoadmapSmall";
import { IRoadmapSmallClass, IRoadmapSmallProps } from "@/types/RoadmapSmallTypes";
import { IPokerDiceHistoryType } from "@/types/GameHistoryTypes";

interface IProps extends IRoadmapSmallProps {
	history: IPokerDiceHistoryType[];
}

//Poker Dice
export default class M14 extends IRoadmapSmallClass {
	props: IProps;

	render() {
		prepareRender(this);

		//Obligatory counters
		let currentType = "";
		
		// Formats this.props.history to desired roadmap
		switch (this.props.filter) {
			case "red-black":
				this.props.history.forEach((item, idx, ary) => {
					let ele = null;
					
					if (!item.angka2) return null;
					
					const angka = item.angka2.split(",");
					let reds = 0, blacks = 0;

					for (const a of angka)
						if (a[1] === "r")
							reds++;
						else if (a[1] === "b")
							blacks++;
					
					//for (var a = 0; a < angka.length; a++)
					//	if (angka[a][1] === "r")
					//		++reds;
					//	else if (angka[a][1] === "b")
					//		++blacks;
		
					if (reds > blacks) {
						currentType = "red";
						ele = getElementDiv(this, ["diamond", "red"], idx, ary);
					} else {
						currentType = "black";
						ele = getElementDiv(this, ["diamond", "black"], idx, ary);
					}
					
					addDisplayTile(this.roadmapArray, ele, currentType, this);
				});
			break;
			case "odd-even":
				this.props.history.forEach((item, idx, ary) => {
					let ele = null;
					
					if (!item.angka2) return null;
					
					const angka = item.angka2.split(",");

					let odds = 0, evens = 0;
					
					for (const a of angka) //var a = 0; a < angka.length; a++)
						if (Number(a[0]) % 2) odds++; //angka[a]
						else evens++;
		
					if (odds > evens) {
						currentType = "odd";
						ele = getElementDiv(this, ["square", "red"], idx, ary);
					} else {
						currentType = "even";
						ele = getElementDiv(this, ["square", "black"], idx, ary);
					}
					
					addDisplayTile(this.roadmapArray, ele, currentType, this);
				});
			break;
			case "small-big":
				this.props.history.forEach((item, idx, ary) => {
					let ele = null;

					if (!item.angka2) return null;
					
					const angka = item.angka2.split(",");

					let total = 0;
					for (const a of angka)
						total += Number(a[0]);

					// for (var a = 0; a < angka.length; a++)
					// 	total += Number(angka[a][0]);
		
					if (total <= 15) {
						currentType = "small";
						ele = getElementDiv(this, ["circle", "red"], idx, ary);
					} else {
						currentType = "big";
						ele = getElementDiv(this, ["circle", "black"], idx, ary);
					}
					
					addDisplayTile(this.roadmapArray, ele, currentType, this);
				});
			break;
			default: return null;
		}
		
		return renderRoadmap(this);
	}
}
